export type PhotoKind = 'account' | 'cv';
export interface PhotoDimensions { width: number; height: number }
export interface PhotoTransform { zoom: number; x: number; y: number }
export const MAX_PHOTO_ZOOM = 4;

export function clampPhotoValue(value: number, min: number, max: number) {
  'worklet';
  return Math.min(max, Math.max(min, value));
}

/** Cover a square viewport; offsets are screen pixels, relative to its centre. */
export function photoDisplaySize(image: PhotoDimensions, viewport: number, zoom = 1) {
  'worklet';
  const scale = viewport / Math.min(image.width, image.height) * zoom;
  return { width: image.width * scale, height: image.height * scale, scale };
}

export function clampPhotoTransform(image: PhotoDimensions, viewport: number, transform: PhotoTransform): PhotoTransform {
  'worklet';
  const zoom = clampPhotoValue(transform.zoom, 1, MAX_PHOTO_ZOOM);
  const size = photoDisplaySize(image, viewport, zoom);
  const maxX = Math.max(0, (size.width - viewport) / 2);
  const maxY = Math.max(0, (size.height - viewport) / 2);
  return { zoom, x: clampPhotoValue(transform.x, -maxX, maxX), y: clampPhotoValue(transform.y, -maxY, maxY) };
}

/** Integer source-pixel rectangle, always square and within the source bounds. */
export function photoCropRectangle(image: PhotoDimensions, viewport: number, transform: PhotoTransform) {
  if (![image.width, image.height, viewport].every(value => Number.isFinite(value) && value >= 1)
    || ![transform.zoom, transform.x, transform.y].every(Number.isFinite)) {
    throw new Error('Invalid photo dimensions');
  }
  const current = clampPhotoTransform(image, viewport, transform);
  const size = photoDisplaySize(image, viewport, current.zoom);
  const side = Math.max(1, Math.min(Math.floor(image.width), Math.floor(image.height), Math.floor(viewport / size.scale)));
  return {
    originX: clampPhotoValue(Math.round((image.width - side) / 2 - current.x / size.scale), 0, Math.floor(image.width) - side),
    originY: clampPhotoValue(Math.round((image.height - side) / 2 - current.y / size.scale), 0, Math.floor(image.height) - side),
    width: side,
    height: side,
  };
}

export function photoOutputSize(kind: PhotoKind, cropSide: number) {
  return Math.max(1, Math.min(kind === 'account' ? 512 : 1024, Math.floor(cropSide)));
}
